import { css } from '@emotion/css';

const marqueeStyles = {
    wrap: css`
        padding: 6px 0;
        /* width: 100%; */
        flex: 1;
    `,
    marqueeItem: css`
        white-space: nowrap;
        margin-left: 20px;
        margin-right: 20px;
        color: #fff;
        font-size: 14px;
        position: relative;
        text-decoration: underline;
        cursor: pointer;
    `,
};
export default marqueeStyles;
